export const IS_LOGIN = "loginReducer/IS_LOGIN"
export const ON_LOGIN = "loginReducer/ON_LOGIN"

export const isLogin = (val) => (disptch) =>{
    return disptch({
        type: IS_LOGIN,
        payload: val
    });
}

export const setUserData = (val) => (disptch) =>{
  return disptch({
    type: ON_LOGIN,
    payload: val
  })
}